
import "chartjs-adapter-date-fns";
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import { useStore } from "@/store";

import { formatDdHhmmToHhmm } from "@/logics/diagram";
import Chart from "primevue/chart";

import DiagramMenu from "./DiagramMenu.vue";
import DiagramTimeTableManager from "./DiagramTimeTableManager.vue";
import DiagramTrainTypeManager from "./DiagramTrainTypeManager.vue";
import DiagramStationManager from "./DiagramStationManager.vue";

export default defineComponent({
  components: {
    Chart,
    DiagramMenu,
    DiagramTimeTableManager,
    DiagramTrainTypeManager,
    DiagramStationManager,
  },
  setup() {
    const chartRef = ref<Chart>();

    const width = ref(2000);
    const canZoomIn = computed(() => width.value < 32000);
    const canZoomOut = computed(() => width.value > 1000);
    const zoomIn = () => {
      if (canZoomIn.value) {
        width.value *= 2;
      }
    };
    const zoomOut = () => {
      if (canZoomOut.value) {
        width.value /= 2;
      }
    };

    const graphOptions = computed(() => ({
      tension: 0,
      animation: false,
      responsive: true,
      aspectRatio: width.value / 350,
      parsing: {
        xAxisKey: "time",
        yAxisKey: "name",
      },
      indexAxis: "y",
      showLine: true,
      plugins: {
        legend: {
          labels: {
            color: "#495057",
          },
          position: "left",
        },
      },
      elements: {
        line: {
          borderWidth: 1,
        },
      },
      scales: {
        x: {
          min:
            store.getters.getMinAndMaxTimeOnDiagramData.min ||
            "2021-10-14: 04:30",
          max: store.getters.getMinAndMaxTimeOnDiagramData.max,
          type: "time",
          time: {
            parser: "yyyy-MM-dd HH:mm",
            unit: "minute",
            stepSize: 5,
            displayFormats: { minute: "HH:mm" },
            tooltipFormat: "HH:mm",
          },
          ticks: {
            color: "#495057",
          },
          grid: {
            color: "#ebedef",
          },
          position: "top",
        },
        y: {
          ticks: {
            color: "#495057",
            source: "labels",
          },
          grid: {
            color: "#ebedef",
          },
        },
      },
    }));

    const store = useStore();
    const ltdExp = computed(() => store.getters.getTrainType(1));
    const trainTypes = computed(() => store.state.trainTypes);

    const data = computed(() => store.getters.getChatrJsData);
    watch(data, () => {
      store.state.__chartRefresh();
    });
    const showingTrainId = computed(() => store.state.showingTrainId);

    const canAddTrainType = computed<boolean>(() => trainTypes.value.size < 6);
    const addInitialTrainType = () => {
      store.dispatch("addInitialTrainType");
    };

    onMounted(() => {
      if (!chartRef.value) return;
      store.commit("setChartRefresh", { chartRefresh: chartRef.value.refresh });
      store.dispatch("loadData", { id: 1 });
    });

    return {
      data,
      graphOptions,
      width,
      canZoomIn,
      canZoomOut,
      zoomIn,
      zoomOut,
      ltdExp,
      trainTypes,
      formatDdHhmmToHhmm,
      chartRef,
      showingTrainId,
      canAddTrainType,
      addInitialTrainType,
    };
  },
});
